import {DynamicTable} from '../../../../components/DynamicTable'
import PaymentListViewTableRow from './PaymentListViewTableRow'
import {parsePaymentListData} from '../../parsings'
import {PaymentListViewSortableColumns} from '../../utils/config'
import {useContext} from 'react'
import {PaymentCalenderPageContext} from '../../contexts'
import {Pagination} from '../../../../utils/pagination'

const PaymentListViewTable = () => {
  const {
    paymentListData,
    paymentListFilters,
    isLoadingPaymentListData,
    paymentListPagination,
    onPaymentListPageChange,
    onPaymentListSortingChange,
  } = useContext(PaymentCalenderPageContext)

  return (
    <>
      <DynamicTable
        data={paymentListData}
        sortableColumns={PaymentListViewSortableColumns}
        onSortingChange={onPaymentListSortingChange}
        filters={paymentListFilters}
        TableRow={PaymentListViewTableRow}
        tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 mb-3'
        tableHeaderClass='fw-bold text-muted'
        rowParsingFunction={parsePaymentListData}
        loading={isLoadingPaymentListData}
        pagination={paymentListPagination}
        onPageChange={onPaymentListPageChange}
      />
      <Pagination pagination={paymentListPagination} onPageChange={onPaymentListPageChange} />
    </>
  )
}

export default PaymentListViewTable
